import React from 'react';
import { useHistory } from 'react-router-dom';
import PageHeader from 'components/common/general/layouts/PageHeader';

const InitialSeedPageHeader: React.FC = () => {
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.push('/product-templates');
  };

  return <PageHeader title="Initial Seed Product Templates" onRedirect={onBackButtonClick} />;
};

export default InitialSeedPageHeader;
